export default __webpack_public_path__ + "static/catherine-witt-d-3db5d2cde283f40b8aae3cbfcf62ef62.png";